module.exports = __webpack_public_path__ + "media/images/placeholder-tall-0725fb086e23acb04ae5a295bada0780.png";